<template>
  <v-row justify="center">
    <v-dialog
        v-model="dialog"
        scrollable
        max-width="600px"
    >
      <v-card>
        <v-toolbar dark>
          <v-card-title class="headline">
            Renew book
            <hr>
          </v-card-title>

          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-spacer></v-spacer>
            <v-btn icon  @click="closeDialog">
              <i class="fas fa-times"></i>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-btn class="btn" :class="renew_by_days?'btn-primary text-white':'btn-secondary'" large depressed
                     style="width: 100%" @click="renew_by_days=true">Renew By
                Days
              </v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn class="btn  " :class="!renew_by_days?'btn-primary text-white':'btn-secondary'" large depressed
                     style="width: 100%" @click="renew_by_days=false">Renew
                By Date
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="renew_by_days">
              <v-text-field outlined dense v-model="library_setting.renew_day" readonly
                            label="Total days to be renewed"></v-text-field>
            </v-col>
            <v-col cols="12" v-if="!renew_by_days">
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="renew_day"
                      label="Renew up to"

                      readonly prepend-icon=""
                      prepend-inner-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      outlined dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="renew_day"
                    @input="menu = false"
                    :max="max_day"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions >
          <v-spacer></v-spacer>
          <v-btn class="btn btn-standard cancel-btn"
              depressed
              @click="closeDialog()">
            Cancel
          </v-btn>

          <v-btn :loading="loading"
                 class="text-white ml-2 btn btn-primary"
                 depressed
                 @click="renewBook"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import IssueService from "@/core/services/library/issue/IssueService";

const issueService = new IssueService();
export default {
  name: "RenewModal",
  props: ['dialog', 'issue_list', 'user_id', 'library_setting'],
  data() {
    return {
      renew_day: null,
      menu: false,
      loading: false,
      renew_by_days: true
    }
  },
  computed: {
    max_day() {
      this.renew_day = this.$moment(new Date()).add(this.library_setting.renew_day, 'days').format("YYYY-MM-DD");
      return this.$moment(new Date()).add(30, 'days').format("YYYY-MM-DD");
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close_dialog', 'renew_dialog')
    },
    renewBook() {
      this.$confirm({
        message: `Are you sure you want to renew books?`,
        button: {
          no: "No",
          yes: "Yes"
        },
        callback: confirm => {
          if (confirm) {
            this.initiateReturn();
          }
        }
      });
    },
    initiateReturn() {
      this.loading = true;
      let data = {
        user_id: this.user_id,
        issue_list: this.issue_list,
        return_date: this.return_date,
        max_deu_date: this.library_setting.max_deu_date,
        flag: this.renew_by_days ? 'days' : 'date',
      };
      if (this.renew_by_days) {
        data.renew_by_days = this.library_setting.renew_day;
        data.max_deu_date = this.library_setting.max_deu_date
      } else {
        data.renew_upto_date = this.renew_day
        let dueDays = parseInt(this.library_setting.max_deu_date) - parseInt(this.library_setting.renew_day);
        data.due_upto_date = this.$moment(data.renew_upto_date).add(dueDays, 'days').format("YYYY-MM-DD");
      }
      issueService.renewBooks(data).then(response => {
        this.$snotify.success("Book has been renewed successfully")
        this.closeDialog();
      }).catch(error => {
        this.$snotify.error("Something went wrong. Please try again later")
      }).finally(() => {
        this.loading = false;
      })
    }
  }
}
</script>

<style scoped>

</style>